const Marquee = ({ items }) => {
  const Row = () => (
    <div className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="whitespace-nowrap px-10 font-serif text-xl md:text-2xl font-light text-white/70 tracking-wide">
            {item}
          </span>
          <span className="text-brand-gold text-xs" aria-hidden="true">◆</span>
        </div>
      ))}
    </div>
  );
  return (
    <div
      data-testid="marquee-banner"
      className="relative overflow-hidden border-y border-white/10 bg-brand-surface/60 py-6"
    >
      <div className="marquee-track flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
};

export default Marquee;
